import {inject, Injectable} from "@angular/core";
import {UserHttp} from "../data-access/http/user.http";
import {UserState} from "../data-access/state/user.state";
import {combineLatestWith, forkJoin, map, Observable, switchMap, tap} from "rxjs";
import {User} from "../models/user";
import {UserMapper} from "./mapper/user.mapper";
import {UserDto} from "../data-access/http/dto/user.dto";
import {ChantierMapper} from "../../home/domain/mapper/chantier.mapper";
import {Chantier} from "../models/chantier";
import {ChantierHttp} from "../../home/data-access/http/chantier.http";
import {ChantierDto} from "../../home/data-access/http/dto/chantier.dto";
import {HomeState} from "../../home/data-access/state/home.state";

@Injectable({ providedIn: 'root' })
export class UserDomain {
  private readonly userHttp = inject(UserHttp)
  private readonly chantierHttp = inject(ChantierHttp)
  private readonly userState = inject(UserState)
  private readonly chantierState = inject(HomeState)
  // Selectors
  connectedUser$: Observable<User> = this.userState.store
    .select(UserState.getConnectedUser)
    .pipe(map(UserMapper.dtoToModel))
  selectableUserChantiers$: Observable<Chantier[]> = this.userState.store.select(UserState.getUserChantiers).pipe(
    combineLatestWith(this.chantierState.store.select(HomeState.getSelectedChantier)),
    map(([chantierDtos, selectedChantier]: [ChantierDto[], ChantierDto]) =>
      chantierDtos.filter((chantierDto) => chantierDto.code !== selectedChantier?.code)
    ),
    map(ChantierMapper.dtosToModels)
  )

  connectedUser(): User {
    return UserMapper.dtoToModel(this.userState.store.selectSnapshot(UserState.getConnectedUser))
  }

  // Actions

  loadConnectedUser(codeChantier?: string): Observable<ChantierDto[]> {
    return this.userHttp.connectUser(codeChantier).pipe(
      tap((connectedUser) =>
        this.userState.store.update((state) => ({
          ...state,
          connectedUser,
        }))
      ),
      switchMap((user: UserDto) =>
        forkJoin(user.chantiers.map((chantierCode) => this.chantierHttp.getChantierByCode(chantierCode)))
      ),
      tap((userChantiers) => {
        this.userState.store.update((state) => ({
          ...state,
          userChantiers,
        }))
      })
    )
  }
}
